module.exports = __webpack_public_path__ + "img/2.469079ff.jpg";